module.exports = {

  // LandingPageHero
  landingPageHeroTitle: 'Office Space Calculator for Growing Teams',
  landingPageHeroSubtitle: 'Figuring out how much office space you need is the first step in any office search. CBRE’s free office space calculator estimates the right size based on your team’s headcount, how you work and the spaces you need. Results use industry benchmarks trusted by workplace professionals. When you’re ready, a CBRE broker can help you find matching spaces.',
  landingPageHeroImgAlt: 'Preview of a results page space program from the homepage of Spacer by CBRE',
  landingPageImage: '/png/homepage-results-page-in-browser-spacer-by-cbre.png',
  // LandingPageContent
  landingPageContentTitle: 'What you get',

  // StepsSummary
  stepsSummarySubtitle1: '',
  stepsSummaryTitle1: 'Built on CBRE Workplace Benchmarks',
  stepsSummaryText1: 'The calculator uses industry benchmarks developed by CBRE\'s workplace professionals — covering square feet per person, space mix, seat ratios and density. These figures reflect how real offices work, giving you a reliable starting point for your search.',
  stepsSummaryImgAlt1: 'Illustration of people standing on a giant laptop on the Home page of Spacer by CBRE',

  stepsSummarySubtitle2: '',
  stepsSummaryTitle2: 'Answers Based on How Your Team Works',
  stepsSummaryText2: 'Your recommendation is shaped by how your organization operates — not just your headcount. Tell us about your workstyle, attendance patterns and priorities. The calculator adjusts the output to reflect your specific situation.',
  stepsSummaryImgAlt2: 'Illustration of a neighborhood block on the Home page of Spacer by CBRE',

  stepsSummarySubtitle3: '',
  stepsSummaryTitle3: 'Results You Can Act On',
  stepsSummaryText3: 'Your recommended office size comes with a full space breakdown. Share it with a CBRE broker to shortlist properties, or hand it to your architect to start planning your layout.',
  stepsSummaryImgAlt3: 'Illustration of a girl working at a desk on the Home page of Spacer by CBRE',

  // LandingPageSecondaryHero
  landingPageSecondaryHeroImgAlt: 'Illustration of people building space recommendations on the Home page of Spacer by CBRE',
  landingPageSecondaryHeroTitle: 'Tell us a little about your company. We’ll tell you how much office space you need.'

};
